import { getUserData } from '@/assets/api/ucenter';
import store from '@/store';

// 对当前用户信息进行缓存。如果不存在数据。就请求接口。然后把信息放到store中
export const cacheUserData = () => {
    let { userInfo } = store.getters;
    
    return new Promise((resolve,reject) => {
        // 对用户数据进行缓存
        if (!userInfo || !Object.keys(userInfo).length) {
            getUserData()
                .then(({ data }) => {
                    store.commit("user/SET_USER_INFO", data);
                    resolve(data);
                });
        } else {
            resolve(userInfo)
        }
    });
}
export const clearCachedUserData = ()=>{
    store.commit("user/SET_USER_INFO", null);
}
